<template>
  <div class="tab-content tab-view-list">
    <list-form
      :visible-header-controls="!disabledHeaderControls"
      ref="listForm"
      :config="listFormConfig"
      :formModel="getListFormModel"
      @onGet="handleGet"
    >
      <template v-slot="{ data, item, updateDataItem, updateModelItem }">
        <form-details
          :disabled="!isAvailableToEdit"
          :companyID="companyID"
          :data="data"
          :model="getListFormModel"
          :config="{ id: listFormConfig.id }"
          @change="updateDataItem($event)"
          @updateModelItem="updateModelItem"
        />
      </template>
    </list-form>
    <editor
      :config="{id: listFormConfig.id}"
      :companyID="companyID"
    ></editor>
  </div>
</template>

<script>
import Tab from './../Tab'
import ListFormConfig from './ListFormCinfig'
import { waitValue } from '@/utils/promises'

export default {
  name: 'TabDetails',
  mixins: [Tab],
  components: {
    'form-details': () => import(/* webpackChunkName: 'Companies' */ './Form'),
    'list-form': () => import(/* webpackChunkName: 'ListForm' */ '@/components/ListForm/Index.vue'),
    'editor': () => import(/* webpackChunkName: 'Companies' */ './Editor.vue')
  },
  data () {
    return {
      listFormConfig: ListFormConfig,
      disabledHeaderControls: true
    }
  },
  methods: {
    getListForm () {
      return waitValue(() => this.$refs.listForm)
    },
    getListFormModel () {
      return {
        id: null,
        creditDays: '',
        supplierCredit: '',
        creditLine: '',
        cofaceCredit: '',
        currencyID: null,
        companyID: null
      }
    },
    handleGet (data) {
      this.disabledHeaderControls = data.length >= 1
    },
    // Mixin Tabs
    handleChangeCompanyID (companyID) {
      this.getListForm()
        .then((listForm) => {
          if (!companyID) return
          listForm.setFilters(`companyID == ${companyID}`)
          listForm.loadData()
        })
    }
  }
}
</script>
